import type {
  Segment,
  SegmentState,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/segments';

export const get = (state: SegmentState, id: string): Segment | undefined => state.byId[id];
export const all = (state: SegmentState): Record<string, Segment> => state.byId;
